import React, { useState, useEffect, useRef } from "react";
import { Grid, IconButton, Paper } from "@material-ui/core";
import TableSkeleton from "../../../../StyledComponents/TableSkeleton";
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  Button,
  Box,
  Checkbox,
  TableBody,
  Typography,
  TextField,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { Delete } from "@material-ui/icons";
import "./style.css";
import EmptyData from "../../../../StyledComponents/Table/EmptyData";
import { useSelector } from "react-redux";
import Heading from "../../../../StyledComponents/Heading/Heading";
import LinearProgress from "@mui/material/LinearProgress";
import Stack from "@mui/material/Stack";
import getParameterByName from "../../../../Functions/functions";
import {
  DataSheetGrid,
  checkboxColumn,
  textColumn,
  keyColumn,
  intColumn,
  floatColumn,
  resizeColumn,
} from "react-datasheet-grid";
const useStyles = makeStyles({
  table: {
    minWidth: 650,

    "& .MuiTableCell-root": {
      borderLeft: "1px solid rgba(224, 224, 224, 1)",
    },

    // tablebody: {
    //   "&.MuiTableRow-root:last-child td": {
    //     borderLeft: "1px solid #000",
    //   },
    // },
  },
});

function PODetail({
  formState,
  setSelectedTotal,
  setFormState,
  disabled,
  deletee,
  Invoice_id,
  selected_PoRec,
  setSelected_PoRec,
  checkedBox,
  loading,
  edit,
  selectedRole,
  ipUser,
}) {
  const tableData = {
    assetNumber: "",
    balancE_QTY: 0,
    balancE_VAL: 0,
    conD_COUNT: "",
    conD_ST_NO: "",
    currency: "",
    disT_IND: "",
    dN_NO: "",
    doc_Date: "",
    doC_YEAR: "",
    delivUnit: "",
    Dlvqty: "", //
    inpuT_VAL: 0,
    inpuT_QTY: 0,
    invoicE_QTY: 0,
    invoicE_VAL: 0,
    kschl: "",
    ordeR_QTY: "",
    ordeR_UNIT: "",
    poItem: "",
    poItemText: "",
    poNumber: "",
    plant: "",
    uniT_PRICE : "",
    poqty: "", //
    quantity: "",
    refDoc: "",
    reF_DOC_IT: "",
    reF_DOC_NO: "",
    reF_DOC_NO_LONG: "",
    seQ_NO: "",
    sheeT_ITEM: "",
    sheeT_NO: "", //
    sO_ITEM: "",
    sO_NO: "",
    vText: "",
    Val_Gr_Loc: "", //
    Val_Iv_Loc: "", //
    val_Loccur: "",
    Vendor_Code: "", //
    Vendor_Name: "", //
    doc_Date: "",
    invoice_Id: Number(Invoice_id),
    selected: false,
  };
  const classes = useStyles();
  const editable = getParameterByName("edit");
  const roleName = getParameterByName("roleName");
  const status = getParameterByName("status");
  const [cellState, setCellState] = useState("");
  const role = useSelector((state) => state.Role);
  // function to compare selected PO records GRN Amount with Invoice Amount so we can proceed
  const checkBal = (tempArray) => {
    let t = 0;
    if (!ipUser) {
      let totalItems = tempArray.filter((data) => data.selected == true);
      t = totalItems
        .map((balance) =>
          Number(
            balance?.inpuT_VAL?.toFixed(2) || balance?.INPUT_VAL?.toFixed(2)
          )
        )
        .reduce((total, item) => total + item, 0);
    } else if (ipUser) {
      let totalItems = tempArray;
      t = totalItems
        .map((balance) =>
          Number(
            balance?.inpuT_VAL?.toFixed(2) || balance?.INPUT_VAL?.toFixed(2)
          )
        )
        .reduce((total, item) => total + item, 0);
    }

    setSelectedTotal(t);
  };

  const addInput = () => {
    setFormState((formState) => ({
      ...formState,
      invoicePORef_List: [...formState.invoicePORef_List, tableData],
    }));
  };

  const deleteInput = (index) => {
    const filteredData = formState?.invoicePORef_List?.filter(
      (x, i) => i !== index
    );
    setFormState((formState) => ({
      ...formState,
      invoicePORef_List: filteredData,
    }));
    checkBal(filteredData);
  };
  const changeHandler = (e, index) => {
    const { name, value } = e.target;

    if (name === "val_Loccur") {
      let tempArray = formState.invoicePORef_List;

      tempArray[index] = {
        ...formState.invoicePORef_List[index],
        [name]: value,
        inpuT_VAL: (
          Number(value) - Number(tempArray[index].invoicE_VAL)
        ).toString(),
      };

      setFormState((formState) => ({
        ...formState,
        invoicePORef_List: tempArray,
      }));
      checkBal(tempArray);
    } else if (name === "invoicE_VAL") {
      let tempArray = formState.invoicePORef_List;

      tempArray[index] = {
        ...formState.invoicePORef_List[index],
        [name]: value,
        inpuT_VAL: (
          Number(tempArray[index].val_Loccur) - Number(value)
        ).toString(),
      };

      setFormState((formState) => ({
        ...formState,
        invoicePORef_List: tempArray,
      }));
      checkBal(tempArray);
    } else if (name === "quantity") {
      let tempArray = formState.invoicePORef_List;
      tempArray[index] = {
        ...formState.invoicePORef_List[index],
        [name]: value,
        inpuT_QTY: Number(value) - Number(tempArray[index].invoicE_QTY),
      };

      setFormState((formState) => ({
        ...formState,
        invoicePORef_List: tempArray,
      }));
      checkBal(tempArray);
    } else if (name === "invoicE_QTY") {
      let tempArray = formState.invoicePORef_List;
      tempArray[index] = {
        ...formState.invoicePORef_List[index],
        [name]: value,
        inpuT_QTY: (
          Number(tempArray[index].quantity) - Number(value)
        ).toString(),
      };

      setFormState((formState) => ({
        ...formState,
        invoicePORef_List: tempArray,
      }));
      checkBal(tempArray);
    } else if (name === "inpuT_QTY") {
      let tempArray = formState.invoicePORef_List;
      if (
        value <=
        Number(tempArray[index].quantity) - Number(tempArray[index].invoicE_QTY)
      ) {
        tempArray[index] = {
          ...formState.invoicePORef_List[index],
          [name]: Number(value),
          inpuT_VAL: Number(
            (
              (Number(tempArray[index].val_Loccur) /
                Number(tempArray[index].quantity)) *
              Number(value)
            )?.toFixed(2)
          ),
        };
        setFormState((formState) => ({
          ...formState,
          invoicePORef_List: tempArray,
        }));

        checkBal(tempArray);
      }
    } else if (name === "inpuT_VAL") {
      let tempArray = formState.invoicePORef_List;

      // the below commented code if user not allow to add value more the invoice 5%
      // it works on entered the value, i have also add functionality on input (min, max) so we need this commented code. for now.

      // if (
      //   // value <=
      //   // Number(tempArray[index].val_Loccur) -
      //   // Number(tempArray[index].invoicE_VAL)
      //   value <=
      //   0.05 *
      //   ((Number(tempArray[index].val_Loccur) /
      //     Number(tempArray[index].quantity)) *
      //     Number(tempArray[index].inpuT_QTY)) +
      //   (Number(tempArray[index].val_Loccur) /
      //     Number(tempArray[index].quantity)) *
      //   Number(tempArray[index].inpuT_QTY)
      // ) {
      tempArray[index] = {
        ...formState.invoicePORef_List[index],
        [name]: Number(Number(value)?.toFixed(2)),
      };
      setFormState((formState) => ({
        ...formState,
        invoicePORef_List: tempArray,
      }));
      checkBal(tempArray);
      // }
    } else {
      let tempArray = formState.invoicePORef_List;
      tempArray[index] = {
        ...formState.invoicePORef_List[index],
        [name]: value,
      };
      setFormState((formState) => ({
        ...formState,
        invoicePORef_List: tempArray,
      }));
      checkBal(tempArray);
    }
  };

  const handleGridChange = (data, operation) => {
    let rowIndex = cellState?.cell?.row;
    let name = cellState?.cell?.colId;

    let tempArray = data;

    // for consumed quantity
    if (name === "selected") {
      if (tempArray[rowIndex]?.selected === true) {
        tempArray[rowIndex].selected = true;
        setFormState({
          ...formState,
          invoicePORef_List: tempArray,
        });
        checkBal(tempArray);
      } else {
        let tempArray = formState.invoicePORef_List;
        tempArray[rowIndex].selected = false;

        setFormState({
          ...formState,
          invoicePORef_List: tempArray,
        });
        checkBal(tempArray);
      }
    }
    if (name === "Quantity") {
      //  GRN quantity
      tempArray[rowIndex] = {
        ...formState.invoicePORef_List[rowIndex],
        // [name]: Number(value).toFixed(0),
        Quantity: Number(tempArray[rowIndex].Quantity),
        INPUT_QTY:
          Number(tempArray[rowIndex].Quantity) -
          // Number(value).toFixed(0) -
          Number(tempArray[rowIndex].INVOICE_QTY),
        // Number(tempArray[index].INVOICE_QTY).toFixed(0),
      };

      setFormState((formState) => ({
        ...formState,
        invoicePORef_List: tempArray,
      }));
      checkBal(tempArray);
    } else if (name === "INVOICE_QTY") {
      tempArray[rowIndex] = {
        ...formState.invoicePORef_List[rowIndex],
        // [name]: Number(value).toFixed(0),
        INVOICE_QTY: Number(tempArray[rowIndex].INVOICE_QTY),
        INPUT_QTY:
          Number(tempArray[rowIndex].Quantity) -
          // Number(tempArray[index].Quantity).toFixed(0) -
          Number(tempArray[rowIndex].INVOICE_QTY),
        // Number(value).toFixed(0),
        // INPUT_VAL:Number(tempArray[index].Val_Loccur) - Number(tempArray[index].Val_Loccur)/Number( tempArray[index].Quantity)*Number(value)
      };

      setFormState((formState) => ({
        ...formState,
        invoicePORef_List: tempArray,
      }));
      checkBal(tempArray);
    } else if (name === "Val_Loccur") {
      tempArray[rowIndex] = {
        ...formState.invoicePORef_List[rowIndex],
        Val_Loccur: Number(tempArray[rowIndex].Val_Loccur),
        INPUT_VAL: Number(
          (
            Number(tempArray[rowIndex].Val_Loccur) -
            Number(tempArray[rowIndex].INVOICE_VAL)
          )?.toFixed(2)
        ),
        // INVOICE_VAL: Number(value)/Number( tempArray[index].Quantity)*Number(tempArray[index].INVOICE_QTY)
      };

      setFormState((formState) => ({
        ...formState,
        invoicePORef_List: tempArray,
      }));
      checkBal(tempArray);
    } else if (name === "INVOICE_VAL") {
      // consumed Amount
      if (
        tempArray[rowIndex].INVOICE_VAL <=
        (Number(tempArray[rowIndex].Val_Loccur) / // GRN amount
          Number(tempArray[rowIndex].Quantity)) * // GRN quantity
          Number(tempArray[rowIndex].INVOICE_QTY) //  consumed quantity
      ) {
        tempArray[rowIndex] = {
          ...formState.invoicePORef_List[rowIndex],
          INVOICE_VAL: Number(tempArray[rowIndex].INVOICE_VAL),
          INPUT_VAL: Number(
            (
              Number(tempArray[rowIndex].Val_Loccur) -
              Number(tempArray[rowIndex].INVOICE_VAL)
            )?.toFixed(2)
          ),
        };

        setFormState((formState) => ({
          ...formState,
          invoicePORef_List: tempArray,
        }));
        checkBal(tempArray);
      }
    } else if (name === "INPUT_QTY") {
      // if (
      //   value <=
      //   Number(tempArray[index].Quantity) - Number(tempArray[index].INVOICE_QTY)
      // ) {
      tempArray[rowIndex] = {
        ...formState.invoicePORef_List[rowIndex],
        INPUT_QTY: Number(tempArray[rowIndex].INPUT_QTY),
        INPUT_VAL: Number(
          (
            (Number(tempArray[rowIndex].Val_Loccur) /
              Number(tempArray[rowIndex].Quantity)) *
            Number(tempArray[rowIndex].INPUT_QTY)
          )?.toFixed(2)
        ),
      };
      setFormState((formState) => ({
        ...formState,
        invoicePORef_List: tempArray,
      }));
      checkBal(tempArray);
      // }
    } else {
      setFormState((formState) => ({
        ...formState,
        invoicePORef_List: tempArray,
      }));
      checkBal(tempArray);
    }

    //
    //
    // const updatedData = data.map((row, index) => {
    //
    //   let rowData = row;
    //   // yaha per masla ho jana..
    //   if (index  == operation[0].toRowIndex) { // operation[0].toRowIndex replace with state row
    //     // ya sari execute ni hoti?
    //     // hn g bas 1st one execute hoti ha
    //     // Quantity ye wali hoi ha bas remaining nahi hotin

    //     if (row?.INPUT_QTY) {

    //       const subtract = Number(row.Quantity) - Number(row.INVOICE_QTY);
    //

    //       rowData = { ...row, INPUT_QTY: subtract };
    //     }
    //     if (row?.INPUT_VAL) {
    //       const subtract = Number(row.Val_Loccur) - Number(row.INVOICE_VAL);
    //

    //       rowData = { ...row, INPUT_VAL: subtract };
    //     }

    //     // if (row?.INVOICE_VAL) {
    //     //   if (
    //     //     row?.INVOICE_VAL <=
    //     //     (Number(row.Val_Loccur) / Number(row.Quantity)) *
    //     //       Number(row.INVOICE_QTY)
    //     //   ) {
    //     //     const subtract = Number(row.Val_Loccur) - Number(row.INVOICE_VAL);
    //     //     rowData = { ...row, INPUT_VAL: subtract };
    //     //   }
    //     // }
    //     // if (row?.INPUT_QTY) {
    //     //   const divide =
    //     //     (Number(row.Val_Loccur) / Number(row.Quantity)) *
    //     //     Number(row.INPUT_QTY);
    //     //   rowData = { ...row, INPUT_VAL: divide };
    //     // }
    //     // rowData ya yaha per return hona hae per agar koi na mathc kiya to masla ho jana
    //     //  empty chale jana hn g

    //   }
    //   return rowData; // theek raha ga, agar empth huva to check kr lyty hain

    //   //  if (index + 1 == operation[0].toRowIndex){

    //   //   const Input_VAL = Number(row.Val_Loccur) -  Number(row.INVOICE_VAL);
    //   //
    //   //     return { ...row, INPUT_VAL: Input_VAL };
    //   //

    //   // }
    //   // wasa ka waasa hi return ho jata hae
    // });
    //
    // setFormState((formState) => ({
    //   ...formState,
    //   invoicePORef_List: updatedData,
    // }));
    // checkBal(updatedData);
  };
  // const changeHandler = (e, index) => {
  //   const { name, value } = e.target;
  //   let tempArray = formState.invoicePORef_List;
  //   tempArray[index] = {
  //     ...formState.invoicePORef_List[index],
  //     [name]: value,
  //   };

  //   setFormState((formState) => ({
  //     ...formState,
  //     invoicePORef_List: tempArray,
  //   }));
  //   checkBal(tempArray);
  // };
  const selectRec = (e, index) => {
    if (e.target.checked == true) {
      let tempArray = formState.invoicePORef_List;

      tempArray[index].selected = true;
      setFormState({
        ...formState,
        invoicePORef_List: tempArray,
      });
      checkBal(tempArray);
    } else {
      let tempArray = formState.invoicePORef_List;
      tempArray[index].selected = false;

      setFormState({
        ...formState,
        invoicePORef_List: tempArray,
      });
      checkBal(tempArray);
    }

    // if (e.target.checked == true) {
    //   setSelected_PoRec((selected_PoRec) => ({
    //     ...selected_PoRec,
    //     invoicePORef_List: [...selected_PoRec.invoicePORef_List, item],
    //   }));
    // } else {
    //   const filteredData = selected_PoRec?.invoicePORef_List?.filter(
    //     (x) => x !== item
    //   );
    //   setSelected_PoRec((selected_PoRec) => ({
    //     ...selected_PoRec,
    //     invoicePORef_List: filteredData,
    //   }));
    // }
  };
  const getFirstNonEmptyKey = (...keys) => {
    for (const key of keys) {
      if (key) return key;
    }
    return "";
  };
  // const AmountCell = React.memo(
  //   ({ active, rowData, setRowData,focus  }) => {
  //     const inputRef = useRef(null);

  //     useEffect(() => {
  //       if (focus) {
  //         inputRef.current?.focus();
  //       } else {
  //         inputRef.current?.blur();
  //       }
  //     }, [focus]);

  //     return (
  //       <TextField
  //       type="number"
  //       // name="amount"
  //       // size="small"
  //       // value={rowData?.amount}
  //       sx={{
  //         "& legend": { display: "none" },
  //         "& fieldset": { top: 0 },
  //       }}
  //       variant="standard"
  //       required
  //       value={rowData}
  //       min={0}
  //       InputProps={{
  //         inputProps: { min: 0, step:"0.01" },
  //         disableUnderline: true,
  //       }}

  //       onChange={(e) => setRowData(e.target.value)}

  //     />
  //     )
  //   }
  // )
  // const intColumn = {
  //   component: AmountCell,
  //   deleteValue: () => '',
  //   disableKeys: true,
  //   keepFocus: true,
  //   copyValue: ({ rowData }) => rowData,
  //   pasteValue: ({ value }) => value,
  // }
  const [columns, setColumns] = useState([
    {
      ...keyColumn("selected", checkboxColumn),
      title: "",
      disabled: true,
    },

    {
      // ...keyColumn((disabled && editable === "true") ? "poItem" : "POItem"  , textColumn),
      // ...keyColumn(("poItem" || "POItem"  )   , textColumn),
      ...keyColumn("poItem" || "POItem", textColumn),
      title: "Item #",
      disabled: true,
      minWidth: 160,
      // disabled: ({ disabled }) => (disabled ? true : false),
    },
    {
      // ...keyColumn((disabled || editable === "true") ? "poNumber" : "PONumber"  , textColumn),
      ...keyColumn("poNumber" || "PONumber", textColumn),

      title: "PO Number",
      minWidth: 180,
      disabled: true,

      // disabled: ({ disabled }) => (disabled ? true : false),
    },

    {
      // ...keyColumn("RefDoc", textColumn),
      ...keyColumn("refDoc" || "RefDoc", textColumn),

      title: "GRN No",
      minWidth: 180,
      disabled: true,

      // disabled: ({ disabled }) => (disabled ? true : false),

      // grow: 2,
    },
    {
      // ...keyColumn("Quantity", textColumn),
      ...keyColumn("quantity" || "Quantity", textColumn),

      title: "GRN Quantity",
      minWidth: 160,
      // disabled: ({ disabled }) => (disabled ? true : false),
      disabled: true,

      // grow: 2,
    },
    {
      // ...keyColumn("Val_Loccur", textColumn),
      ...keyColumn("val_Loccur" || "Val_Loccur", textColumn),

      title: "GRN Amount",
      minWidth: 160,
      // grow: 4,
      // disabled: ({ disabled }) => (disabled ? true : false),
      disabled: true,
    },
    {
      // ...keyColumn("INVOICE_QTY", textColumn),
      ...keyColumn("invoicE_QTY" || "INVOICE_QTY", textColumn),

      title: "Consumed Quantity",
      minWidth: 160,
      // grow: 3,
      // disabled: ({ disabled }) => (disabled ? true : false),
      disabled: true,
    },
    {
      // ...keyColumn("INVOICE_VAL", textColumn),
      ...keyColumn("invoicE_VAL" || "INVOICE_VAL", textColumn),

      title: "Consumed Amount",
      minWidth: 160,
      // grow: 3,
      disabled: true,
    },
    {
      // ...keyColumn("INPUT_QTY", textColumn),
      ...keyColumn("inpuT_QTY" || "INPUT_QTY", floatColumn),

      title: " Invoice Qty",
      minWidth: 180,
      // grow: 2,
      // disabled: ({ disabled }) => (disabled ? true : false),
      disabled: disabled,
    },
     {
      ...keyColumn("uniT_PRICE", textColumn),
      title: "Unit Price",
      disabled: true,

      // disabled: ({ disabled }) => (disabled ? true : false),
    },
    {
      // ...keyColumn("INPUT_VAL", textColumn),
      ...keyColumn("inpuT_VAL" || "INPUT_VAL", floatColumn),
      minWidth: 180,
      title: "Invoice Amt",

      grow: 2,

      disabled: disabled,
    },
    {
      // ...keyColumn("Currency", textColumn),
      ...keyColumn("currency" || "Currency", textColumn),

      title: "Currency",
      // width: 150,
      disabled: true,

      grow: 2,
      // disabled: ({ disabled }) => (disabled ? true : false),
    },
    {
      ...keyColumn("poItemText" || "POItemText", textColumn),
      title: " PO Text",
      disabled: true,
      minWidth: 310,
    },
    {
      ...keyColumn("plant" || "Plant", textColumn),
      title: "Plant",
      disabled: true,
      minWidth: 160,
    },
    
    {
      ...keyColumn("dN_NO" || "DN_NO", textColumn),
      title: "Delivery Note",
      minWidth: 160,
      disabled: true,
    },

    {
      ...keyColumn("assetNumber" || "AssetNumber", textColumn),
      title: "Asset No",
      disabled: true,
      minWidth: 160,
    },

    {
      ...keyColumn("vText" || "VText", textColumn),
      title: "Text",
      disabled: true,
      minWidth: 160,
    },

    // will be called to handle pasting. Because we chose to copy the label, we have to transform it back to a value on pasting.
  ]);
  return (
    <Grid container style={{ margin: "30px 0px" }}>
      <Grid item xs={12} sm={12} md={12} lg={12} style={{ width: "0" }}>
        <Heading title="PO Details" />

        {/*<TableContainer
          className="scrollable"
          style={{
            maxHeight: "400px",
            minHeight: "100px",
            overflowY: "auto",
          }}
        >
          <Table
            className={classes.table}
            aria-label="a dense table"
            // padding="normal"

            size="small"
          >
            <TableHead style={{ position: "sticky", top: 0, zIndex: "1" }}>
              <TableRow sx={{ backgroundColor: "#EFF2F4" }}>
                <TableCell
                  align="center"
                  sx={{ fontWeight: "bold", color: "#031C30" }}
                >
                  #
                </TableCell>
                {checkedBox && (
                  <TableCell
                    sx={{ fontWeight: "bold", color: "#031C30" }}
                  ></TableCell>
                )}
                <TableCell sx={{ fontWeight: "bold", color: "#031C30" }}>
                  Item #
                </TableCell>
                <TableCell sx={{ fontWeight: "bold", color: "#031C30" }}>
                  PO Number
                </TableCell>
                <TableCell sx={{ fontWeight: "bold", color: "#031C30" }}>
                  GRN No
                </TableCell>
                <TableCell sx={{ fontWeight: "bold", color: "#031C30" }}>
                  GRN Quantity
                </TableCell>
                <TableCell sx={{ fontWeight: "bold", color: "#031C30" }}>
                  GRN Amount
                </TableCell>
                <TableCell sx={{ fontWeight: "bold", color: "#031C30" }}>
                  Consumed Quantity
                </TableCell>
                <TableCell sx={{ fontWeight: "bold", color: "#031C30" }}>
                  Consumed Amount
                </TableCell>
                <TableCell sx={{ fontWeight: "bold", color: "#031C30" }}>
                  Invoice Qty
                </TableCell>
                <TableCell sx={{ fontWeight: "bold", color: "#031C30" }}>
                  Invoice Amt
                </TableCell>
                <TableCell sx={{ fontWeight: "bold", color: "#031C30" }}>
                  Currency
                </TableCell>
                <TableCell sx={{ fontWeight: "bold", color: "#031C30" }}>
                  PO Text
                </TableCell>
                <TableCell sx={{ fontWeight: "bold", color: "#031C30" }}>
                  Plant
                </TableCell>
                <TableCell sx={{ fontWeight: "bold", color: "#031C30" }}>
                  Delivery Note
                </TableCell>
                <TableCell sx={{ fontWeight: "bold", color: "#031C30" }}>
                  Asset No.
                </TableCell>
                <TableCell sx={{ fontWeight: "bold", color: "#031C30" }}>
                  Text
                </TableCell>
                {deletee && (
                  <TableCell
                    style={{
                      textAlign: "center",
                      fontWeight: "bold",
                      color: "#031C30",
                    }}
                  >
                    Action
                  </TableCell>
                )}
              </TableRow>
            </TableHead>
            <TableBody>
              {formState?.invoicePORef_List?.length > 0 &&
                formState?.invoicePORef_List?.map((item, index) => {
                  return (
                    <TableRow
                      key={index}
                      sx={{
                        backgroundColor: item?.selected && "rgb(240,240,240)",
                      }}
                    >
                      <TableCell align="center" scope="row">
                        {index + 1}
                        {item.selected}
                      </TableCell>
                      {checkedBox && (
                        <TableCell>
                          <Checkbox
                            checked={item?.selected ? true : false}
                            onChange={(e) => {
                              selectRec(e, index);
                            }}
                          />
                        </TableCell>
                      )}
                      <TableCell>
                        <input
                          type="number"
                          size="small"
                          style={{
                            outline: "none",
                            border: "none",
                            backgroundColor:
                              item?.selected && "rgb(240,240,240)",
                          }}
                          variant="standard"
                          name="poItem"
                          value={item?.poItem || item?.POItem}
                          disabled={disabled}
                          onChange={(event) => changeHandler(event, index)}
                        />
                      </TableCell>
                      <TableCell>
                        <input
                          type="number"
                          size="small"
                          style={{
                            outline: "none",
                            border: "none",
                            backgroundColor:
                              item?.selected && "rgb(240,240,240)",
                          }}
                          variant="standard"
                          name="poNumber"
                          value={item?.poNumber || item?.PONumber}
                          disabled={disabled}
                          onChange={(event) => changeHandler(event, index)}
                        />
                      </TableCell>

                      <TableCell>
                        <input
                          type="number"
                          size="small"
                          style={{
                            outline: "none",
                            border: "none",
                            backgroundColor:
                              item?.selected && "rgb(240,240,240)",
                          }}
                          variant="standard"
                          name="refDoc"
                          value={item?.refDoc || item?.RefDoc || 0}
                          disabled={disabled}
                          onChange={(event) => changeHandler(event, index)}
                        />
                      </TableCell>
                      <TableCell>
                        <input
                          type="number"
                          size="small"
                          style={{
                            outline: "none",
                            border: "none",
                            backgroundColor:
                              item?.selected && "rgb(240,240,240)",
                          }}
                          variant="standard"
                          name="quantity"
                          value={item?.quantity || item?.Quantity}
                          disabled={disabled}
                          onChange={(event) => changeHandler(event, index)}
                        />
                      </TableCell>

                      <TableCell>
                        <input
                          type="number"
                          size="small"
                          style={{
                            outline: "none",
                            border: "none",
                            backgroundColor:
                              item?.selected && "rgb(240,240,240)",
                          }}
                          variant="standard"
                          name="val_Loccur"
                          value={item?.val_Loccur || item?.Val_Loccur}
                          disabled={disabled}
                          onChange={(event) => changeHandler(event, index)}
                        />
                      </TableCell>
                      <TableCell>
                        <input
                          type="number"
                          size="small"
                          style={{
                            outline: "none",
                            border: "none",
                            backgroundColor:
                              item?.selected && "rgb(240,240,240)",
                          }}
                          variant="standard"
                          name="invoicE_QTY"
                          value={item?.invoicE_QTY || item?.INVOICE_QTY}
                          disabled={disabled}
                          onChange={(event) => changeHandler(event, index)}
                        />
                      </TableCell>

                      <TableCell>
                        <input
                          type="number"
                          size="small"
                          style={{
                            outline: "none",
                            border: "none",
                            backgroundColor:
                              item?.selected && "rgb(240,240,240)",
                          }}
                          variant="standard"
                          name="invoicE_VAL"
                          value={item?.invoicE_VAL || item?.INVOICE_VAL}
                          disabled={disabled}
                          onChange={(event) => changeHandler(event, index)}
                        />
                      </TableCell>
                      <TableCell>
                        <input
                          type="number"
                          size="small"
                          style={{
                            outline: "none",
                            border: "none",
                            backgroundColor:
                              item?.selected && "rgb(240,240,240)",
                          }}
                          variant="standard"
                          name="inpuT_QTY"
                          value={item?.inpuT_QTY || item?.INPUT_QTY || 0}
                          disabled={ipUser ? false : disabled}
                          // min="0"
                          step="0.00001"
                          // max={
                          //   (item?.quantity || item?.Quantity) -
                          //   (item?.invoicE_QTY || item?.INVOICE_QTY)
                          // }
                          onChange={(event) => changeHandler(event, index)}
                        />
                      </TableCell>
                      <TableCell>
                        <input
                          type="number"
                          size="small"
                          style={{
                            outline: "none",
                            border: "none",
                            backgroundColor:
                              item?.selected && "rgb(240,240,240)",
                          }}
                          variant="standard"
                          name="inpuT_VAL"
                          value={item?.inpuT_VAL || item?.INPUT_VAL || 0}
                          disabled={ipUser ? false : disabled}
                          // min="0"
                          step="0.00001"
                          // max={
                          //   (item?.val_Loccur || item?.Val_Loccur) -
                          //   (item?.invoicE_VAL || item?.INVOICE_VAL)
                          // }
                          // min={(
                          //   (Number(item?.val_Loccur || item?.Val_Loccur) /
                          //     Number(item?.quantity || item?.Quantity)) *
                          //     Number(item?.inpuT_QTY || item?.INPUT_QTY) -
                          //   (Number(item?.val_Loccur || item?.Val_Loccur) /
                          //     Number(item?.quantity || item?.Quantity)) *
                          //     Number(item?.inpuT_QTY || item?.INPUT_QTY) *
                          //     0.05
                          // ).toFixed(0)}
                          // max={(
                          //   (Number(item?.val_Loccur || item?.Val_Loccur) /
                          //     Number(item?.quantity || item?.Quantity)) *
                          //     Number(item?.inpuT_QTY || item?.INPUT_QTY) +
                          //   (Number(item?.val_Loccur || item?.Val_Loccur) /
                          //     Number(item?.quantity || item?.Quantity)) *
                          //     Number(item?.inpuT_QTY || item?.INPUT_QTY) *
                          //     0.05
                          // ).toFixed(0)}
                          onChange={(event) => changeHandler(event, index)}
                        />
                      </TableCell>
                      <TableCell>
                        <input
                          type="text"
                          size="small"
                          style={{
                            outline: "none",
                            border: "none",
                            backgroundColor:
                              item?.selected && "rgb(240,240,240)",
                          }}
                          variant="standard"
                          name="currency"
                          value={item?.currency || item?.Currency}
                          disabled={disabled}
                          onChange={(event) => changeHandler(event, index)}
                        />
                      </TableCell>
                      <TableCell>
                        <input
                          type="text"
                          size="small"
                          style={{
                            outline: "none",
                            border: "none",
                            backgroundColor:
                              item?.selected && "rgb(240,240,240)",
                          }}
                          variant="standard"
                          name="POItemText"
                          value={item?.poItemText || item?.POItemText}
                          disabled={disabled}
                          onChange={(event) => changeHandler(event, index)}
                        />
                      </TableCell>
                      <TableCell>
                        <input
                          type="number"
                          size="small"
                          style={{
                            outline: "none",
                            border: "none",
                            backgroundColor:
                              item?.selected && "rgb(240,240,240)",
                          }}
                          variant="standard"
                          name="Plant"
                          value={item?.plant || item?.Plant || 0}
                          disabled={disabled}
                          onChange={(event) => changeHandler(event, index)}
                        />
                      </TableCell>
                      <TableCell>
                        <input
                          type="number"
                          size="small"
                          style={{
                            outline: "none",
                            border: "none",
                            borderBottom: "none",
                            backgroundColor:
                              item?.selected && "rgb(240,240,240)",
                          }}
                          variant="standard"
                          name="DN_NO"
                          value={item?.dn_no || item?.dN_NO || item?.DN_NO || 0}
                          disabled={disabled}
                          onChange={(event) => changeHandler(event, index)}
                        />
                      </TableCell>
                      <TableCell>
                        <input
                          type="number"
                          size="small"
                          style={{
                            outline: "none",
                            border: "none",
                            backgroundColor:
                              item?.selected && "rgb(240,240,240)",
                          }}
                          variant="standard"
                          name="AssetNumber"
                          value={item?.assetNumber || item?.AssetNumber || 0}
                          disabled={disabled}
                          onChange={(event) => changeHandler(event, index)}
                        />
                      </TableCell>
                      <TableCell>
                        <input
                          type="text"
                          size="small"
                          style={{
                            outline: "none",
                            border: "none",
                            backgroundColor:
                              item?.selected && "rgb(240,240,240)",
                          }}
                          variant="standard"
                          name="VText"
                          value={item?.vText || item?.VText}
                          disabled={disabled}
                          onChange={(event) => changeHandler(event, index)}
                        />
                      </TableCell>
                      {deletee && (
                        <TableCell align="center">
                          <IconButton size="small">
                            <Delete
                              color="error"
                              fontSize="small"
                              onClick={() => {
                                deleteInput(index);
                              }}
                            />
                          </IconButton>
                        </TableCell>
                      )}
                    </TableRow>
                  );
                })}
            </TableBody>
            {loading && <TableSkeleton noOfColumns={13} noOfLines={3} />}
          </Table>
          {formState?.invoicePORef_List?.length === 0 && !loading ? (
            <EmptyData />
          ) : (
            ""
          )}
        </TableContainer>*/}

        {formState.invoicePORef_List?.length === 0 && !loading ? (
          <EmptyData />
        ) : loading ? (
          <>
            <Stack sx={{ width: "100%", color: "grey.500" }} spacing={2}>
              <LinearProgress color="info" />
              <LinearProgress color="info" />
              <LinearProgress color="info" />
            </Stack>
          </>
        ) : (
          <DataSheetGrid
            style={{
              "--dsg-header-text-color": "#031C30",
            }}
            // value={ formState.invoicePORef_List }
            value={[
              ...formState?.invoicePORef_List?.map((item) => {
                const newItem = { ...item };
                if (newItem.hasOwnProperty("INPUT_VAL")) {
                  newItem["INPUT_VAL"] = Number(
                    Number(newItem["INPUT_VAL"])?.toFixed(2)
                  );
                  newItem["Currency"]='PKR'
                  newItem["currency"]='PKR'
                } else if (newItem.hasOwnProperty("inpuT_VAL")) {
                  newItem["inpuT_VAL"] = Number(
                    Number(newItem["inpuT_VAL"])?.toFixed(2)
                  );
                  newItem["Currency"]='PKR'
                  newItem["currency"]='PKR'
                }
                return newItem;
              }),
            ]}
            onChange={handleGridChange}
            columns={columns}
            lockRows={
              disabled || formState.invoicePORef_List.length === 0
                ? true
                : false
            }
            //  lockRows={false}

            onActiveCellChange={(res) => {
              setCellState(res);
            }}

            // onDelete={handleDelete}
          />
        )}

        {!disabled && (
          <Box display="flex" justifyContent={"flex-end"} mt={2}>
            <Button
              color="secondary"
              variant="contained"
              onClick={addInput}
              style={{ display: edit == "false" ? "none" : "" }}
            >
              Add New Row
            </Button>
          </Box>
        )}
      </Grid>
    </Grid>
  );
}

export default React.memo(PODetail);
